import {
    CLEAN_FILTER_PAYMENT_SUCCESS
} from '../constants'

export function reducer(state, action) {
    if(action.type===CLEAN_FILTER_PAYMENT_SUCCESS){
        return {
            ...state,
            filterPaymentsData: null
        }
    }else{
        return state
    }
}
